module.exports = __webpack_public_path__ + "img/icon-pause--orange.d352c4da.svg";